export function getOrgPermissions(filterData, staticFilters) {
    if (staticFilters === null || staticFilters === void 0 ? void 0 : staticFilters.orgPermissions) {
        return staticFilters === null || staticFilters === void 0 ? void 0 : staticFilters.orgPermissions;
    }
    if (filterData === null || filterData === void 0 ? void 0 : filterData.pending) {
        return ['manage-members', 'manage-organization'];
    }
    return;
}
